<div class="landing">
  <button
    *ngIf="!userLogged"
    class="landing-button my-account-primary-link--m"
    (click)="login()"
  >
    <em class="fas fa-power-off"></em>
    <span class="landing-button-text">{{ 'sso.dologin' | translate }}</span>
  </button>
  <a *ngIf="userLogged" [routerLink]="['/']" class="my-account-primary-link--m">
    Ir a la home</a
  >
</div>
